// pages/NewsDetail.js
import React from "react";
import { useParams } from "react-router-dom";
//import newsData from "../../assets/newsdat";
import newsData from "../../assets/news/newsdata";
import "./NewsDetails.css";

function NewsDetail() {
  const { id } = useParams();
  const news = newsData.find((item) => item.id.toString() === id);
  console.log(news);
  if (!news) {
    return (
      <div className="news-not-found">
        <h2>News not found</h2>
      </div>
    );
  }

  return (
    <section className="news-detail-section">
      <div className="container">
        <h1 className="sub-heading news-detail-heading">{news.name}</h1>
        <p className="news-date">{news.data}</p>
        <img src={news.image} alt={news.name} className="detail-image" />
        <p className="news-detail">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{news.detail}</p>
        <p className="news-detail">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{news.detail2}</p>
      </div>
    </section>
  );
}

export default NewsDetail;
